import { centerNode } from "@/components/FlowSheetEditor/utils"
import { UnitSimOperation, getTopologyState, groupUnitsByStatus } from "@/store/flowsheet/flowsheet.slice"
import { EquipmentType } from "@/types/common"
import { AimOutlined } from "@ant-design/icons"
import { useGraphInstance, Node } from "@antv/xflow"
import { Button, Space, Table, Tabs, TabsProps } from "antd"
import { useMemo } from "react"
import { useSelector } from "react-redux"

const LogTable = ({data}: {data: UnitSimOperation[]}) => {
  const graph = useGraphInstance();

  const centerContent = (record: UnitSimOperation) => {
    const {uuid, type} = record;
    if (!graph) return;
    if (type === EquipmentType.Stream) {
      const stream = graph.getCellById(uuid)
      if (stream) {
        graph.centerCell(stream)
        return
      }
      const distStream = graph.getEdges().find(item => item.data.streamId === uuid)
      if (distStream) {
        graph.centerCell(distStream)
      }
    } else {
      const node = graph.getCellById(uuid);
      if (node) {
        centerNode(graph, node as Node)
      }
    }
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (val, record) => {
        return <div style={{width: 100}} className="text-ellipsis" title={val}>
          {val}
        </div>
      }
    },
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message',
    },
    {
      title: 'Actions',
      render: (_, record) => {
        return <Space>
          <Button icon={<AimOutlined />} title="Show" onClick={() => centerContent(record)} />
        </Space>
      }
    },
  ]
  return <Table dataSource={data} columns={columns} pagination={{hideOnSinglePage: true}} />
}

export const SimLogsPanel = () => {
  const simState = useSelector(getTopologyState)
  const data = useMemo(() => {
    return groupUnitsByStatus(simState?.operations || [])
  }, [simState])

  const items: TabsProps['items'] = [
  {
    key: '1',
    label: 'Errors',
    children: <div>
      <LogTable data={data.errors}/>
    </div>,
  },
  {
    key: '2',
    label: 'Warning',
    children:  <div>
      <LogTable data={data.warnings}/>
    </div>,
  },
];

  return <div className="p-1">
    <Tabs defaultActiveKey="1" items={items} />
  </div>
}